import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'

export const useEmployeeId = (id: string | undefined): Employee => {
  const employee =
    id !== undefined
      ? employees.find({
          id: +id,
        })
      : null

  if (!employee) {
    throw Error(`Error finding employees with id = ${id}`)
  }

  return employee
}
